/**
 * Keyboard shortcuts the app really has, in one list so the "?" sheet and the
 * Help article cannot drift from the handlers. Each entry names where its
 * handler lives.
 */

export type Shortcut = { keys: string[]; label: string; group: string };

const mod = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform) ? "⌘" : "Ctrl";

export const SHORTCUTS: Shortcut[] = [
  // CommandPalette.tsx
  { group: "Anywhere", keys: [mod, "K"], label: "Search and jump to anything" },
  { group: "Anywhere", keys: ["?"], label: "Show this list" },
  { group: "Anywhere", keys: ["Esc"], label: "Close the open dialog, menu or panel" },
  // useGoChords below
  { group: "Go to", keys: ["g", "c"], label: "Chat" },
  { group: "Go to", keys: ["g", "w"], label: "Work" },
  { group: "Go to", keys: ["g", "s"], label: "Schedule" },
  // Chat composer
  { group: "Writing a message", keys: ["Enter"], label: "Send" },
  { group: "Writing a message", keys: ["Shift", "Enter"], label: "New line" },
  { group: "Writing a message", keys: ["↑", "↓"], label: "Pick a suggestion after typing @" },
  { group: "Writing a message", keys: ["Enter"], label: "Insert the highlighted suggestion" },
  // Feed
  { group: "Feed", keys: [mod, "Enter"], label: "Post" },
];

/** Where each "g x" chord goes. */
export const GO_CHORDS: Record<string, string> = { c: "/chat", w: "/work", s: "/schedule" };

/** True when a keystroke belongs to a text field and must not trigger a shortcut. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}
